import { useState, useEffect } from "react";
import { getListTenant } from "../request/request";
import styles from './ModalLicense.module.scss'

export default function SelectTenantU(props: any) {
    const [tenants, setTenants] = useState([{ id: '', Name: '', Domain: '' }]);
    const [tenatselect, setTenantSelect] = useState('')

    useEffect(() => {
        getListTenant().then(response => {
            const tenantData = response.data;
            setTenants(response.data);
            if (tenantData.length > 0) {
                setTenantSelect(tenantData[0].id);
                props.setTenantSelect(tenantData[0].id);
            }
        });
    }, []);

    return (
        <div>
            <label className='form-label fs-6 fw-bolder text-marino required form-label f-parrafo'>Tenant</label>
            <select
                required
                className={`form-select form-control-solid border-gray-300 f-parrafo ${styles['custom-select-padding']}`}
                aria-label="Select Tenant"
                onChange={e => (setTenantSelect(e.target.value), props.setTenantSelect(e.target.value))}
                value={tenatselect}
            >
                {tenants.map((tenant: any, i: any) =>
                    <option key={i} value={tenant.id}>{tenant.Name}</option>
                )}
            </select>
        </div>
    );
}
